import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { hotelApi } from './query';
import { THotelInfo, THotelSliceState } from './types';

const initialState: THotelSliceState = {
  hotelDetail: null,
};

const hotelSlice = createSlice({
  name: 'hotel',
  initialState,
  reducers: {
    setHotelDetail: (state, action: PayloadAction<THotelInfo | null>) => {
      state.hotelDetail = action.payload;
    },
  },
  extraReducers: builder => {
    const { GetHotel } = hotelApi.endpoints;

    builder
      .addMatcher(GetHotel.matchFulfilled, (state, { payload }) => {
        state.hotelDetail = payload.data;
      })
      .addMatcher(GetHotel.matchRejected, state => {
        state.hotelDetail = null;
      });
  },
});

export const { setHotelDetail } = hotelSlice.actions;
export default hotelSlice.reducer;
